import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";

import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { axiosPrivate } from "../../axios/axios";
import ErrorProps from "../../Component/Errorprops";
import { api } from "../API/config";
import { commonCss } from "../../StyleConfig/CommonCss";
import { getOTPAndEmail } from "../../Redux/authentication";
import AuthShell, { authFieldSx, authButtonSx } from "./AuthShell";

const GetEmail = () => {
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    emailId: "",
  };
  const onSubmit = (values, { resetForm }) => {
    setLoading(true);
    const getLink = api.account.forgetPassword;
    axiosPrivate
      .post(`${getLink}`, values)
      .then((res) => {
        // dispatch({type:"reset",payload:{email:values.email,code:base64_encode(res.data.data)}})
        dispatch(getOTPAndEmail({ emailId: values.emailId }));
        toast.success("Please Check Your Email For OTP");
        setLoading(false);
        navigate("/setpassword");
        // if(res.data.data.userRole===4){
        //   navigate("/user")

        // }else{
        //   navigate("/reportform")
        // }

        resetForm();
      })
      .catch((err) => {
        toast.error(
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {err.response.data.errors !== null
              ? err.response.data.errors.map((d, i) => (
                  <Typography key={i}>
                    {i + 1 + ". " + d.errorMessage}
                  </Typography>
                ))
              : err.response.data.message}
          </Box>,
        );
        console.log(err);
        setLoading(false);
      });
  };
  const validationSchema = Yup.object({
    emailId: Yup.string()
      .required("Email is required")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Invalild Email",
      ),
  });
  return (
    <AuthShell
      title="Reset Password"
      subtitle="Enter your email address and we'll send you instructions to reset your password."
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1.1rem",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
            <InputLabel>
              <Typography
                variant="body2"
                fontWeight={commonCss.labelFontWeight}
                color={commonCss.labelInputColor}
              >
                Email
              </Typography>
            </InputLabel>
            <Field
              as={TextField}
              type="email"
              fullWidth
              size="small"
              name="emailId"
              sx={authFieldSx}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AlternateEmailIcon sx={{ color: commonCss.blue }} />
                  </InputAdornment>
                ),
              }}
            />
            <ErrorMessage name="emailId">
              {(error) => <ErrorProps>{error}</ErrorProps>}
            </ErrorMessage>
          </Box>

          <Button
            type="submit"
            variant="contained"
            disabled={isLoading}
            fullWidth
            sx={authButtonSx(isLoading)}
          >
            {isLoading ? "Loading..." : "Submit"}
          </Button>

          <Box sx={{ textAlign: "center", mt: "0.5rem" }}>
            <Typography sx={{ color: "#6C757D", fontSize: "0.9rem" }}>
              Back to{" "}
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  color: commonCss.blue,
                  fontWeight: 600,
                }}
              >
                Log in
              </Link>
            </Typography>
          </Box>
        </Form>
      </Formik>
    </AuthShell>
  );
};

export default GetEmail;




